<div class="o-wrapper">
  <div class="d-flex justify-content-center desktop pt-4 pl-3">
    <div class="text-right pr-4">
      <div><img src="assets/images/team/Life_at_ketto_1.png" width= "271.04px" height="271.27px"/></div>
      <div class="mt-3"><img class="img2" src="assets/images/team/Life_at_ketto_2.png" width= "224px" height="152px"/></div>
    </div>
    <div class="align-self-center">
      <div><img src="assets/images/team/annual-outing-2.jpg" width= "446.8px" height="281.39px"/></div>
    </div>
    <div class="align-self-center pl-4">
      <div><img src="assets/images/team/Life_at_ketto_6.png" width= "305.97px" height="162.46px"/></div>
      <div class="mt-3"><img src="assets/images/team/Life_at_ketto_7.png" width= "300px" height="176.15px"/></div>
    </div>
  </div>

  <div class="d-flex justify-content-center mobile pb-4 pt-3">
    <!-- Column 1 -->
    <div class="mr-3">
      <div class="mb-3 img1"></div>
      <div class="mb-3"><img src="assets/images/team/Life_at_ketto_6.png" width= "154px" height="154px"/></div>
      <div class="img3"></div>
    </div>

    <!-- Column 2 -->
    <div>
      <div class="mb-3"><img src="assets/images/team/Life_at_ketto_2.png" width= "154px" height="154px"/></div>
      <div class="mb-3"><img src="assets/images/team/Life_at_ketto_1.png" width= "154px" height="154px"/></div>
      <div><img src="assets/images/team/Life_at_ketto_7.png" width= "154px" height="154px"/></div>
    </div>
  </div>


</div>
